import { getFilteredCohortAbTestKeys } from 'nove8/helpers/getFilteredCohortAbTestKeys'
import { Countries } from 'root-constants'

export const getFirebaseKeys = (
  cohort: string,
  language: string,
  remoteConfigVariant: Record<string, string> | string,
  country: string,
) => {
  const keysArray = getFilteredCohortAbTestKeys(
    cohort,
    country as Countries,
    language,
  )

  if (!keysArray.length) return ''

  return keysArray
    .map((key) =>
      typeof remoteConfigVariant === 'string'
        ? remoteConfigVariant
        : remoteConfigVariant[key],
    )
    .join(',')
}
